import * as Frigade from '@frigade/react'
import { PropsWithChildren } from 'react'

import { useAdminContext } from '~/components/hooks/useAdminContext'
import { useCurrentUser } from '~/components/hooks/useCurrentUser'
import { useFirm } from '~/components/hooks/useFirm'
import { avatarSidToUrl } from '~/util/s3'

export function FrigadeEngageWrapper({ children }: PropsWithChildren) {
  const user = useCurrentUser()
  const firm = useFirm()
  const { isImpersonating } = useAdminContext()
  const isSystemAdmin = user.admin

  const frigadeApiKey = process.env.NEXT_PUBLIC_FRIGADE_ENGAGE_API_KEY

  if (!frigadeApiKey || isImpersonating || isSystemAdmin) {
    return <>{children}</>
  }

  const [firstName, ...lastNameParts] = user.fullName.split(' ')
  const lastName = lastNameParts.join(' ')
  const imageUrl = user.avatarSid ? avatarSidToUrl(user.avatarSid) : undefined
  const userProperties = {
    name: user.fullName,
    firstName: firstName ?? user.fullName,
    lastName: lastName ?? '',
    email: user.email,
    imageUrl,
    role: user.role,
    timeCreated: user.timeCreated,
  }

  const groupProperties = {
    name: firm.name,
    timeCreated: firm.timeCreated,
    isDemo: firm.isDemo,
  }

  return (
    <Frigade.Provider
      apiKey={frigadeApiKey}
      userId={user.sid}
      userProperties={userProperties}
      groupId={firm.sid}
      groupProperties={groupProperties}
    >
      {children}
    </Frigade.Provider>
  )
}
